export const asgardeoConfig = {
  signInRedirectURL: import.meta.env.VITE_SIGN_IN_URL,
  signOutRedirectURL: import.meta.env.VITE_SIGN_OUT_URL,
  clientID: import.meta.env.VITE_ASGARDEO_CLIENT_ID,
  baseUrl: import.meta.env.VITE_ASGARDEO_BASE_URL,
  scope: ['openid', 'profile', 'email', 'address', 'phone'],
};
